module.exports = __webpack_public_path__ + "img/gree.945b2c32.png";